import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8748a278"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-bottom":"20px"} }
const _hoisted_2 = { class: "amazon-root-categories" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"text-align":"right"} }
const _hoisted_5 = { style: {"font-size":"12px","padding":"0","color":"#666","letter-spacing":"0.8px"} }
const _hoisted_6 = {
  key: 0,
  class: "searchResults"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"display":"block","font-size":"13.7px","font-weight":"300","color":"#666","letter-spacing":"0.7px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */))
const _hoisted_10 = {
  key: 1,
  class: "text-center",
  style: {"font-size":"14px","color":"#666","letter-spacing":"1px","padding":"10px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_category_tree = _resolveComponent("category-tree")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { class: "category-search-results-wrapper" }, {
    default: _withCtx(() => [
      _createCommentVNode("search root categories"),
      _createVNode(_component_el_col, {
        md: 8,
        class: "filters-panel"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_input, {
              modelValue: $data.searchTerm,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.searchTerm) = $event)),
              placeholder: "Filter Root Categories",
              style: {"width":"90%"}
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createCommentVNode(" amazon or ebay root categories list. "),
          _createElementVNode("div", _hoisted_2, [
            (!$props.searchLoading)
              ? (_openBlock(), _createBlock(_component_category_tree, {
                  key: 0,
                  categories: $options.filteredSearchRoots,
                  level: 0,
                  "search-results-paths": $options.searchResultsPaths,
                  "marketplace-id": $props.marketplaceId,
                  "category-tree-check-action": $options.categoryTreeCheckAction
                }, null, 8 /* PROPS */, ["categories", "search-results-paths", "marketplace-id", "category-tree-check-action"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading Categories"))
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" search results "),
      _createVNode(_component_el_col, {
        md: 16,
        class: "results-panel"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString($options.filteredSearchResults?$options.filteredSearchResults.length:0) + " categories found. ", 1 /* TEXT */)
          ]),
          _createCommentVNode(" Search Results  "),
          ($props.searchResults && $props.searchResults.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredSearchResults, (sr, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "searchItem",
                    onClick: ($event: any) => ($options.categorySelected(sr))
                  }, [
                    _createTextVNode(_toDisplayString(sr.category_name) + " ", 1 /* TEXT */),
                    _createElementVNode("small", _hoisted_8, _toDisplayString(sr.path_name), 1 /* TEXT */),
                    _hoisted_9
                  ], 8 /* PROPS */, _hoisted_7))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " No results found. "))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}